import React from 'react';
import { Modal } from '@ver-uds/react';
import { Alert, Button, ButtonGroup } from '@ver-uds/uswds-react';
import AlertConstants from '../../../constants/AlertConstants';

export type ExistingEverifyUserModalProps = {
  when: boolean;
  onContinue: () => void;
  onCancel: () => void;
};

const ExistingEverifyUserModal = ({ when, onContinue, onCancel }: ExistingEverifyUserModalProps): JSX.Element => {
  return (
    <Modal
      id="existing-everify-user-modal"
      header="Existing E-Verify User"
      open={when}
      close={onCancel}
      hasDismissButton={false}
    >
      <Modal.Content>
        <div data-testid="modal-alert-text">
          <Alert status="info" slim>
            <Alert.Text>{AlertConstants.EVERIFY_USERS_CHECK_EMAIL_MFA}</Alert.Text>
          </Alert>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <ButtonGroup>
          <Button type="button" data-testid="cancel-button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" data-testid="continue-button" variant="primary" onClick={onContinue}>
            Continue
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default ExistingEverifyUserModal;
